<template>
  <v-icon
    v-if="howlerState.state == 'running'"
    color="green"
  >
    mdi-volume-high
  </v-icon>
  <v-icon
    v-else
    color="red"
  >
    mdi-volume-mute
  </v-icon>
</template>
<script>
import { Howler } from 'howler';

export default {
  name: 'SoundIndicator',
  data() {
    return {
      howlerState: Howler,
    };
  },
};
</script>
